import css from 'styled-jsx/css';
import { colors, fonts, screen } from 'components/styles/variables';

export const styles = css`
  .filter-pills-list {
    padding: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    display: flex;
    width: 100vw;
    white-space: nowrap;
  }

  .clear-filters-button {
    font-family: ${fonts.default};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    display: flex;
    align-items: center;
    color: #f20902;
    margin-left: 6px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    outline: inherit;
  }

  .filter-pills-border {
    display: none;
    height: 36px;
    width: 1px;
    margin: 0 12px;
    background: ${colors.G2};
  }

  @media (min-width: ${screen.smMin}) {
    .filter-pills-border {
      display: flex;
    }
    .filter-pills-list {
      padding: 2px 12px 9px 0px;
      overflow-x: auto;
      width: 100%;
      display: flex;
      flex-flow: wrap;
    }
    .clear-filters-button {
      margin-bottom: 9px;
    }
  }
`;
